// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bold-600{
    font-weight: 600;
}
h2{
    font-weight: 600;
    color: black;
    font-family: 'Montserrat';
}
.front{
    margin-top: 80px;
    margin-bottom: 300px;
    padding-top: 36px;
     /* background-color: #1b57d9; */
     background-image: url(/assets/images/front/Rectangle_info.svg);
}
.front_c{
    margin-bottom: 130px !important;
    padding-top: 50px !important;
    height: 540px !important;
    overflow: hidden;
}
.front_p{
    margin-bottom: 200px !important;
    /* padding-top: 50px !important; */
}
.rate{
    position: absolute;
    width: 100%;
    top: 110px;
}
label{
    color: black;
    font-weight: 500;
}
.card .form-control{
    border: 1px solid #c3c3c3;
    height: 70px;
}
.shadow {
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.10)!important;
}
.copy{
    position: absolute;
    border-radius: 60px;
    padding: 20px 60px;
    background: #0070C0;
    text-align: center;
    font-size: 26px;
    font-weight: 800;
    font-family: 'Montserrat';
    color: white;
    width: 100%;
    top: 10px;
    cursor: pointer;
}
.block{
    background: #D9D9D9;

}
h6{
    margin: 0;
    font-weight: 500;
    color: #000;
}
.border-right-1{
    border-right: 2px solid #707070;
}
.btn-sign{
    background: #10C7FC;
    padding: 16px 32px;
    height: 70px;
    width: 75%;
    color: white;
    font-size: 24px;
    font-family: 'Roboto';
    font-weight: 500;
}
.btn-login{
    background: white;
    font-size: 24px;
    font-family: 'Roboto';
    font-weight: 500;
    padding: 16px 32px;
    height: 70px;
    width: 75%;
    border: 1px solid #707070;
    color: black;
}
.btns p{
    width: 60%;
    /* text-align: center; */
}
.form-control{
    height: 70px;
}
.w-25{
    height: 50px;
    padding: 6px 22px;
    width: 18% !important;
}
.log{
    position: relative;
}
.letter{
    text-transform: uppercase;
    border-radius: 50%;
    border: 3px solid white;
    padding: 6px;
}
[disabled],disabled,.disabled , .btn .disabled{
    opacity: 1 !important;
}

@media screen and (max-width:600px) {
    .front{
        margin-top: 30px;
        display: none;
    }
    .rate{
        position: relative;
        top: 70px;
        margin-bottom: 170px;
    } 
    .copy{
        border-radius: 30px;
        padding: 12px 24px;
    }
    .border-right-1{
        border-bottom: 2px solid #707070;
    }
    .btn-login,.btn-sign,.btn p{
        width: 100%;
    }
    .mob-promo{
        background: white;
    }
    .font-24,.bold-600{
        font-size: 20px; 
    }
    .form-control{
        height: 44px;
    }
    .w-25{
        height: 46px;
        width: 100% !important;
        padding: 4px 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/studentDashboard/account-info/account-info.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;KAChB,+BAA+B;KAC/B,8DAA8D;AACnE;AACA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,kDAAkD;AACtD;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,eAAe;AACnB;AACA;IACI,mBAAmB;;AAEvB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,gCAAgC;IACpC;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;IACrB;AACJ","sourcesContent":[".bold-600{\n    font-weight: 600;\n}\nh2{\n    font-weight: 600;\n    color: black;\n    font-family: 'Montserrat';\n}\n.front{\n    margin-top: 80px;\n    margin-bottom: 300px;\n    padding-top: 36px;\n     /* background-color: #1b57d9; */\n     background-image: url(/assets/images/front/Rectangle_info.svg);\n}\n.front_c{\n    margin-bottom: 130px !important;\n    padding-top: 50px !important;\n    height: 540px !important;\n    overflow: hidden;\n}\n.front_p{\n    margin-bottom: 200px !important;\n    /* padding-top: 50px !important; */\n}\n.rate{\n    position: absolute;\n    width: 100%;\n    top: 110px;\n}\nlabel{\n    color: black;\n    font-weight: 500;\n}\n.card .form-control{\n    border: 1px solid #c3c3c3;\n    height: 70px;\n}\n.shadow {\n    box-shadow: 0 .5rem 1rem rgba(0,0,0,.10)!important;\n}\n.copy{\n    position: absolute;\n    border-radius: 60px;\n    padding: 20px 60px;\n    background: #0070C0;\n    text-align: center;\n    font-size: 26px;\n    font-weight: 800;\n    font-family: 'Montserrat';\n    color: white;\n    width: 100%;\n    top: 10px;\n    cursor: pointer;\n}\n.block{\n    background: #D9D9D9;\n\n}\nh6{\n    margin: 0;\n    font-weight: 500;\n    color: #000;\n}\n.border-right-1{\n    border-right: 2px solid #707070;\n}\n.btn-sign{\n    background: #10C7FC;\n    padding: 16px 32px;\n    height: 70px;\n    width: 75%;\n    color: white;\n    font-size: 24px;\n    font-family: 'Roboto';\n    font-weight: 500;\n}\n.btn-login{\n    background: white;\n    font-size: 24px;\n    font-family: 'Roboto';\n    font-weight: 500;\n    padding: 16px 32px;\n    height: 70px;\n    width: 75%;\n    border: 1px solid #707070;\n    color: black;\n}\n.btns p{\n    width: 60%;\n    /* text-align: center; */\n}\n.form-control{\n    height: 70px;\n}\n.w-25{\n    height: 50px;\n    padding: 6px 22px;\n    width: 18% !important;\n}\n.log{\n    position: relative;\n}\n.letter{\n    text-transform: uppercase;\n    border-radius: 50%;\n    border: 3px solid white;\n    padding: 6px;\n}\n[disabled],disabled,.disabled , .btn .disabled{\n    opacity: 1 !important;\n}\n\n@media screen and (max-width:600px) {\n    .front{\n        margin-top: 30px;\n        display: none;\n    }\n    .rate{\n        position: relative;\n        top: 70px;\n        margin-bottom: 170px;\n    } \n    .copy{\n        border-radius: 30px;\n        padding: 12px 24px;\n    }\n    .border-right-1{\n        border-bottom: 2px solid #707070;\n    }\n    .btn-login,.btn-sign,.btn p{\n        width: 100%;\n    }\n    .mob-promo{\n        background: white;\n    }\n    .font-24,.bold-600{\n        font-size: 20px; \n    }\n    .form-control{\n        height: 44px;\n    }\n    .w-25{\n        height: 46px;\n        width: 100% !important;\n        padding: 4px 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
